import React from "react";
import { Tooltip } from "../ui";

export const PortalOrderVendorToolTip: React.FC = () => {
  const message = (
    <div>
      <p>For portal order vendors, purchase orders are made via vendor portals/websites rather than email.</p>
      <p>Portal order vendors can have no associated emails.</p>
    </div>
  );

  return <Tooltip message={message} />;
};

export const CollectionOrderVendorToolTip: React.FC = () => {
  const message = <p>For vendors with collection orders, all orders will be collected instead of shipped.</p>;

  return <Tooltip message={message} />;
};

export const IsProFormaVendorToolTip: React.FC = () => {
  const message = (
    <div>
      <p>For pro forma vendors, invoices must be paid before goods are shipped.</p>
      <p>This affects the payment terms and shipping process for purchase orders.</p>
    </div>
  );

  return <Tooltip message={message} />;
};

export const PortalAccessVendorToolTip: React.FC = () => {
  const message = (
    <div>
      <p>Vendor portal access is a beta feature.</p>
      <p>
        If vendor portal access is toggled to enabled, user accounts will be provisioned for each vendor email,
        including any emails added subsequently. They will receive an account activation email.
      </p>
      <p>
        When toggled to disabled or when a vendor is deleted, all vendor's user accounts will be deleted/deactivated.
      </p>
      <p>
        Vendor portal access allows vendors to sign up/log in to HealfOps and update POs directly in the system (e.g.,
        confirmations and shipping details).
      </p>
      <p>Emails associated with a vendor that has portal access will be subject to receiving automated emails.</p>
    </div>
  );

  return <Tooltip message={message} />;
};

export const CustomEmailGreetingToolTip: React.FC = () => {
  const message = (
    <p>
      Custom email greetings override the greeting set in 'Settings' for emails sent to this vendor. Example: 'Hi
      Healf'.
    </p>
  );

  return <Tooltip message={message} />;
};

export const DirectInjectionToAAToolTip: React.FC = () => {
  const message = (
    <div>
      <p>
        When enabled, EU lines on this vendor's POs are split into a separate <strong>AA-xxx</strong> purchase order
        delivered directly to Active Ants (Roosendaal, NL).
      </p>
      <p>UK lines remain on the standard PO-xxx flow and ship to GXO UK.</p>
      <p>
        AA-xxx POs cannot be amended after confirmation. The vendor is responsible for booking the inbound delivery slot
        directly with Active Ants, unless this is a Collection Order Vendor — then Healf arranges the collection and the
        inbound booking.
      </p>
    </div>
  );

  return <Tooltip message={message} />;
};

export const FileTypeVendorToolTip: React.FC = () => {
  const message = (
    <div>
      <p>Choose how this vendor receives Purchase Orders (POs).</p>
      <p>
        <strong>CSV:</strong> POs sent by email and available on the dashboard in CSV.
      </p>
      <p>
        <strong>PDF:</strong> POs sent by email and available on the dashboard in PDF.
      </p>
    </div>
  );

  return <Tooltip message={message} />;
};
